import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row ms-3" }
const _hoisted_2 = { class: "col-lg-5 col-md-6 col-sm-12" }
const _hoisted_3 = { class: "col-lg-5 col-md-6 col-sm-12" }
const _hoisted_4 = { class: "row ms-3" }
const _hoisted_5 = { class: "col-lg-3 col-md-6" }
const _hoisted_6 = { class: "col-lg-3 col-md-6" }
const _hoisted_7 = { class: "col-lg-3 col-md-6" }
const _hoisted_8 = { class: "col-lg-3 col-md-6" }
const _hoisted_9 = { class: "row mt-5 text-center" }
const _hoisted_10 = { class: "col-12" }

import { onMounted, ref, toRefs } from 'vue';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import unemployedPrivateCoachingService from '@/api/Unemployed/PrivateCoaching/index';
import { ErrorToast, SuccessToast } from '@/components/VueToast';
import { useI18n } from 'vue-i18n';
import SaveButton from '@/components/button/SaveButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FurtherTrainingForm',
  props: {
  documentId: {
    type: String,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
},
  emits: ['update:submitForm'],
  setup(__props, { emit: __emit }) {

const props = __props;

const documentId = toRefs(props)['documentId'];
const { t } = useI18n();
const isSubmitting = ref(false);
const emit = __emit;

const formData = ref<any>({
  educationVoucher: false,
  activationAndPlacementVoucher: false,
  costForBooks: false,
  costForAudioUsage: false,
  costForExternalFees: false,
  costForOthers: false,
});

async function submitForm() {
  try {
    await unemployedPrivateCoachingService.saveFurtherTrainingContract(documentId.value, formData.value);

    isSubmitting.value = false;
    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getDocumentData() {
  try {
    const { data } = await unemployedPrivateCoachingService.getFurtherTrainingContract(documentId.value);
    formData.value = { ...data.data};
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await getDocumentData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(submitForm, ["prevent"])
  }, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "row" }, [
      _createElementVNode("h6", { class: "mb-2 text-uppercase ps-3" }, " Die Kosten der Maßnahme werden: ")
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.educationVoucher,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.educationVoucher) = $event)),
          label: "über einen Bildungsgutschein, abgerechnet",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.activationAndPlacementVoucher,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.activationAndPlacementVoucher) = $event)),
          label: "Aktivierungs- und Vermittlungsgutschein",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "row mt-4" }, [
      _createElementVNode("h6", { class: "mb-2 text-uppercase ps-3" }, " In den Lehrgangsgebühren sind die Kosten für: ")
    ], -1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.costForBooks,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.costForBooks) = $event)),
          label: "Bücher",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.costForAudioUsage,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.costForAudioUsage) = $event)),
          label: "Audio-Nutzung",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.costForExternalFees,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.costForExternalFees) = $event)),
          label: "Externe Gebühren",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.costForOthers,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.costForOthers) = $event)),
          label: "Sonstige",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(SaveButton, {
          label: _ctx.$t('general.button.save'),
          loading: isSubmitting.value
        }, null, 8, ["label", "loading"])
      ])
    ])
  ], 32))
}
}

})